import { render, staticRenderFns } from "./AllocationExpert.vue?vue&type=template&id=2d29cb1e&scoped=true&"
import script from "./AllocationExpert.vue?vue&type=script&lang=js&"
export * from "./AllocationExpert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d29cb1e",
  null
  
)

export default component.exports